import React from "react";
import { Field } from "redux-form";
import { spacing } from "../theme";
import Hint from "../Hint";
import Label from "./Label";
import { css } from "glamor";

const container = css({
  display: "flex",
  justifyContent: "center",
  gap: spacing.xs,
  marginBottom: 1,
});
const hintWrapper = {
  marginLeft: spacing.m,
  whiteSpace: "pre-line",
  fontSize: 12,
};

export default function RadioField(props) {
  const { name, value, hint, label, disabled } = props;
  const id = `${name}${value?.toString()}`;

  return (
    <div className={container}>
      <Field
        id={id}
        name={name}
        type="radio"
        component="input"
        value={value?.toString()}
        disabled={disabled}
      />{" "}
      <Label htmlFor={id} disabled={disabled}>
        {label}
      </Label>
      {hint && <Hint style={hintWrapper}>{hint}</Hint>}
    </div>
  );
}
